import axios from 'axios'

const service = axios.create({
  baseURL: '',
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('h5_token')
    if (token && config.url && config.url.indexOf('/admin/') === -1) {
      config.headers['token'] = token
    }
    const adminToken = localStorage.getItem('admin_token')
    if (adminToken && config.url && config.url.indexOf('/admin/') !== -1) {
      config.headers['Admin-Token'] = adminToken
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 200) {
      return res.data
    }
    return Promise.reject(res.message || 'Error')
  },
  error => Promise.reject(error)
)

export default service
